// エクスポート形式 → 拡張子と MIME のマッピング（純関数・DuckDB 非依存）。
//
// 役割: レイヤーエクスポートの形式メタを返す。layer-service.exportLayer が利用する。
//       DuckDB を読み込まない独立モジュールにして node --test で検証可能にしている。
// 未知形式は GeoJSON にフォールバックする。
export function exportSpec(format) {
  switch (format) {
    case 'geoparquet':
      return { ext: 'parquet', mime: 'application/octet-stream' }
    case 'geojson':
    default:
      return { ext: 'geojson', mime: 'application/geo+json' }
  }
}
